import React, {Component} from 'react';
import {
    Icon,
    Timeline
} from 'antd';
import {getWeiboByWeiboId} from "../../actions/weiBo";

class PopoverContent extends Component {
    currentUser;
    weiboId = this.props.weiboId;

    constructor(props)
    {
        super(props);
        this.state = {
            mediaCode: this.props.currentMedia,
            weiboId: this.props.weiboId,
            showContent:""

        };

        this.initWeiboData();

    }

    /* 解析发布状态 */
    transformTimeLineItem(str){
        //模板     "[2019-12-01 17:00:37]开始发布至xx网站/校园新闻",
        //         "[2019-12-01 17:00:38]发布至xx网站/校园新闻成功",
        //         "[2019-12-01 17:00:38]正在发布融媒APP",
        //         "[2019-12-01 17:00:38]发布至融媒APP成功"
        let item = {};
        if(str.indexOf("[") > -1 && str.indexOf("]") > -1){
            item.time = str.substring(str.indexOf("[") +1 ,str.indexOf("]"));
            item.content = str.substring(str.indexOf("]") + 1 );
            if(str.indexOf("开始") === str.indexOf("]") +1 ){
                item.type = "start";
            }else if(str.indexOf("正在") === str.indexOf("]") +1 ){
                item.type = "doing";
            }else if(str.indexOf("成功") === str.length - 2 ){
                item.type = "ok";
            }else if(str.indexOf("失败") > -1){
                item.type = "error";
            }
        }else{
            item.type = "none";
            item.time = "";
            item.content = str;
        }
        return item;
    }

    /* 渲染发布状态 */
    renderingPublishStatusTimeLineItem(item){
        if(item.type === "none"){
            return <Timeline.Item>
                <p>{item.content}</p>
            </Timeline.Item>;
        }else if(item.type === "start"){
            return <Timeline.Item >
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        }else if(item.type === "doing"){
            return <Timeline.Item dot={<Icon type="clock-circle-o" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        }else if(item.type === "ok"){
            return <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        }else if(item.type === "error"){
            return <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        }else{
            return <Timeline.Item dot={<Icon type="clock-circle-o" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        }
    }

    initWeiboData()
    {
        if(this.weiboId > 0)
        {
            getWeiboByWeiboId(this.weiboId,(data)=>{
                if(data)
                {
                    let timeList = [];
                    if(data.publishStatus && data.publishStatus.status === 1)
                    {
                            if(data.publishStatus.processStatus.length > 0){
                                for(let i = 0 ; i < data.publishStatus.processStatus.length ; i ++){
                                    let temp = this.transformTimeLineItem(data.publishStatus.processStatus[i]);
                                    timeList.push(this.renderingPublishStatusTimeLineItem(temp));
                                }
                            }
                        this.setState({
                            showContent:<Timeline>
                                {timeList.map(item=>item)}
                            </Timeline>
                        })
                    }else if(data.statusName === '发布' && data.publishStatus && data.publishStatus.status === 2)
                    {
                        for(let i = 0 ; i < data.publishStatus.processStatus.length ; i ++){
                            let temp = this.transformTimeLineItem(data.publishStatus.processStatus[i]);
                            timeList.push(this.renderingPublishStatusTimeLineItem(temp));
                        }
                        this.setState({
                            showContent:<Timeline>
                                {timeList.map(item=>item)}
                            </Timeline>
                        })
                    }else {
                        this.setState({
                            showContent:"未查询到发布进度"
                        })
                    }
                }
            });
        }
    }

    render()
    {
        return (
            <div>
                {this.state.showContent}
            </div>
        );
    }
}

export default PopoverContent;
